import { createActionGroup, emptyProps, props } from '@ngrx/store';
import {
  Qualification,
  SelectableQualificationDatum,
  SurveyLocaleData,
  AdvancedQualification,
  QualificationCategory,
} from '@ps/survey-utils';

export const SurveyCreationReferenceActions = createActionGroup({
  source: 'Survey Creation Reference',
  events: {
    'Load Qualifications': props<SurveyLocaleData>(),
    'Load Question Categories': emptyProps(),
    'Load Questions': props<{ search: string; categoryIds: number[] }>(),
    'Load Location Conditions': props<{
      dbQualificationCode: number;
      locale: string;
    }>(),
  },
});

export const SurveyCreationReferenceApiActions = createActionGroup({
  source: 'Survey Creation Reference API',
  events: {
    'Load Qualifications Success': props<{
      countryCode: string;
      languageShortCode: string;
      qualifications: Qualification[];
      cachedAt: number;
    }>(),
    'Load Qualifications Failure': props<{
      countryCode: string;
      languageShortCode: string;
      error: string;
    }>(),
    'Load Question Categories Success': props<{
      categories: QualificationCategory[];
      cachedAt: number;
    }>(),
    'Load Question Categories Failure': props<{ error: string }>(),
    'Load Questions Started': props<{ key: string }>(),
    'Load Questions Success': props<{
      key: string;
      questions: AdvancedQualification[];
      cachedAt: number;
    }>(),
    'Load Questions Failure': props<{ key: string; error: string }>(),
    'Load Location Conditions Started': props<{ key: string }>(),
    'Load Location Conditions Success': props<{
      key: string;
      conditions: SelectableQualificationDatum[];
      cachedAt: number;
    }>(),
    'Load Location Conditions Failure': props<{
      key: string;
      error: string;
    }>(),
  },
});
